var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiRrDownload1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-download",
    clipPath: "url(#clip0_72_18640)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.8782 18.122C10.1568 18.4008 10.4876 18.6219 10.8517 18.7728C11.2158 18.9237 11.6061 19.0014 12.0002 19.0014C12.3943 19.0014 12.7846 18.9237 13.1487 18.7728C13.5128 18.6219 13.8436 18.4008 14.1222 18.122L17.3332 14.911C17.5054 14.7206 17.5977 14.4713 17.5911 14.2147C17.5845 13.958 17.4795 13.7138 17.2978 13.5325C17.1161 13.3512 16.8716 13.2467 16.615 13.2406C16.3584 13.2346 16.1092 13.3274 15.9192 13.5L12.9932 16.427L13.0002 1C13.0002 0.734784 12.8948 0.48043 12.7073 0.292893C12.5198 0.105357 12.2654 0 12.0002 0V0C11.735 0 11.4806 0.105357 11.2931 0.292893C11.1056 0.48043 11.0002 0.734784 11.0002 1L10.9912 16.408L8.0812 13.5C7.89356 13.3125 7.63911 13.2072 7.37384 13.2073C7.10857 13.2074 6.8542 13.3129 6.6667 13.5005C6.47919 13.6881 6.3739 13.9426 6.37399 14.2079C6.37409 14.4731 6.47955 14.7275 6.6672 14.915L9.8782 18.122Z",
    fill: "#374957"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23 15.9998C22.7348 15.9998 22.4804 16.1052 22.2929 16.2927C22.1054 16.4803 22 16.7346 22 16.9998V20.9998C22 21.2651 21.8946 21.5194 21.7071 21.7069C21.5196 21.8945 21.2652 21.9998 21 21.9998H3C2.73478 21.9998 2.48043 21.8945 2.29289 21.7069C2.10536 21.5194 2 21.2651 2 20.9998V16.9998C2 16.7346 1.89464 16.4803 1.70711 16.2927C1.51957 16.1052 1.26522 15.9998 1 15.9998C0.734784 15.9998 0.48043 16.1052 0.292893 16.2927C0.105357 16.4803 0 16.7346 0 16.9998L0 20.9998C0 21.7955 0.31607 22.5585 0.87868 23.1212C1.44129 23.6838 2.20435 23.9998 3 23.9998H21C21.7956 23.9998 22.5587 23.6838 23.1213 23.1212C23.6839 22.5585 24 21.7955 24 20.9998V16.9998C24 16.7346 23.8946 16.4803 23.7071 16.2927C23.5196 16.1052 23.2652 15.9998 23 15.9998Z",
    fill: "#374957"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_72_18640"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrDownload1);
export default __webpack_public_path__ + "static/media/fi-rr-download (1).9223bc3ced8cc158d2b6f9c8d34e121f.svg";
export { ForwardRef as ReactComponent };